import React, { useState } from "react";

//UI Material
import {
  Avatar,
  Box,
  Card,
  Grid,
  Stack,
  Tab,
  Tabs,
} from "@mui/material";

//Helpers
import {
  typographyForCustomizedFontSize,
  typographyForSubtitles,
  typographyForText,
} from "../../Helpers/typography";
import { selectProductImage } from "../../Helpers/productSelector";
import { existingProducts } from "../../Helpers/products-specs";
import { selectMonth } from "../../Helpers/date";

//Material Icons
import { CheckCircle } from "@mui/icons-material";

//Function to generate tabs
function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`orders-tabpanel-${index}`}
      aria-labelledby={`orders-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{typographyForText(children)}</Box>}
    </div>
  );
}

export default function ProductCard({ product, data = [], year }) {
  // ==========>Component States<==========
  // State for tab value
  const [tabValue, setTabValue] = useState(0);

  // ==========> Component Functions <==========
  //Function to set tab value
  const handleChange = (_event, newValue) => {
    setTabValue(newValue);
  };

  //Function for giving an index to each tab
  function a11yProps(index) {
    return {
      id: `orders-tab-${index}`,
      "aria-controls": `orders-tabpanel-${index}`,
    };
  }

  //Function to get filtered products by name
  const getOrdersForSpecifiedProduct = () => {
    if (existingProducts.includes(product)) {
      return data.filter((order) => order.productName === product);
    } else {
      return data.filter(
        (order) => !existingProducts.includes(order.productName)
      );
    }
  };

  //Function to get products for a specific product status
  const extractedOrders = (stationsStatus) => {
    let matchingStations = 0;

    for (const order of getOrdersForSpecifiedProduct()) {
      const numberOfMatchingInOrder = order.productsStatus.filter(
        (product) => product.status === stationsStatus
      ).length;

      matchingStations += numberOfMatchingInOrder;
    }

    return matchingStations;
  };

  //Function to get finished products in current month
  const extractedFinishedProductsInCurrentMonth = (status) => {
    let matchingStations = 0;

    for (let order of getOrdersForSpecifiedProduct()) {
      const numberOfMatchingInOrder = order.productsStatus.filter(
        (product) =>
          product.status === status &&
          new Date(product.finishedAt).getMonth() === new Date().getMonth()
      ).length;

      matchingStations += numberOfMatchingInOrder;
    }

    return matchingStations;
  };

  //Function to get percentage of product in all yearly production
  const getPercentageOfProduction = () => {
    let produced = 0;

    for (const order of data) {
      // Verificar el estado de cada objeto
      for (const product of order.productsStatus) {
        if (product.status === "FINISHED") {
          produced++;
        }
      }
    }

    if (produced === 0) {
      return 0;
    } else {
      return Number((100 * extractedOrders("FINISHED")) / produced).toFixed(1);
    }
  };

  // ==========> Component <==========
  return (
    <Card raised sx={{ padding: "15px" }}>
      <Grid container spacing={1} alignItems="center">
        <Grid item xs={8}>
          <Stack
            justifyContent="flex-start"
            alignItems="flex-start"
            textAlign="left"
            sx={{ width: "100%" }}
          >
            {typographyForSubtitles(product, "secondary")}
            {typographyForSubtitles(`${getPercentageOfProduction()}%`)}
            {typographyForCustomizedFontSize(
              `Producción total ${year}`,
              "10px"
            )}
          </Stack>
        </Grid>
        <Grid item xs={4} align="right">
          <Avatar
            sx={{ height: "110px", width: "110px" }}
            alt={`${product}-station-report`}
            src={selectProductImage(product)}
          />
        </Grid>

        <Grid item xs={12}>
          <Box>
            <Tabs
              centered
              indicatorColor="secondary"
              textColor="secondary"
              value={tabValue}
              onChange={handleChange}
              aria-label="product-tabs"
            >
              <Tab
                label={selectMonth()}
                sx={{ fontSize: "11px" }}
                {...a11yProps(0)}
              />
              <Tab
                label="ESTE AÑO"
                sx={{ fontSize: "11px" }}
                {...a11yProps(1)}
              />
            </Tabs>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <TabPanel value={tabValue} index={0}>
            <Grid container>
              <Grid item xs={12}>
                <Stack direction="row" alignItems="center" spacing={1}>
                  <CheckCircle color="success" />
                  {typographyForCustomizedFontSize(
                    extractedFinishedProductsInCurrentMonth("FINISHED"),
                    "25px",
                    null,
                    "bold"
                  )}
                  {typographyForText("finalizadas")}
                </Stack>
              </Grid>
            </Grid>
          </TabPanel>
          <TabPanel value={tabValue} index={1}>
            <Grid container>
              <Grid item xs={12}>
                <Stack direction="row" alignItems="center" spacing={1}>
                  <CheckCircle color="success" />
                  {typographyForCustomizedFontSize(
                    extractedOrders("FINISHED"),
                    "25px",
                    "green",
                    "bold"
                  )}
                  {typographyForText("finalizadas")}
                </Stack>
              </Grid>
            </Grid>
          </TabPanel>
        </Grid>
      </Grid>
    </Card>
  );
}
